import { Search, X } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import type { UserFilters, UserRole, UserStatus } from '../types/user.types';
import { USER_ROLE_CONFIG, USER_STATUS_CONFIG } from '../types/user.types';

interface UsersFiltersProps {
  filters: UserFilters;
  onFiltersChange: (filters: UserFilters) => void;
}

export function UsersFilters({ filters, onFiltersChange }: UsersFiltersProps) {
  const hasFilters = filters.search || filters.role || filters.status;

  const handleClearFilters = () => {
    onFiltersChange({});
  };

  return (
    <div className="flex flex-col sm:flex-row gap-3">
      {/* Recherche */}
      <div className="relative flex-1 max-w-md">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input
          placeholder="Rechercher par nom, email..."
          value={filters.search || ''}
          onChange={(e) =>
            onFiltersChange({ ...filters, search: e.target.value || undefined })
          }
          className="pl-9"
        />
      </div>

      {/* Filtre par rôle */}
      <Select
        value={filters.role || 'all'}
        onValueChange={(value) =>
          onFiltersChange({
            ...filters,
            role: value === 'all' ? undefined : (value as UserRole),
          })
        }
      >
        <SelectTrigger className="w-[180px]">
          <SelectValue placeholder="Rôle" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Tous les rôles</SelectItem>
          {(Object.keys(USER_ROLE_CONFIG) as UserRole[]).map((role) => (
            <SelectItem key={role} value={role}>
              {USER_ROLE_CONFIG[role].label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      {/* Filtre par statut */}
      <Select
        value={filters.status || 'all'}
        onValueChange={(value) =>
          onFiltersChange({
            ...filters,
            status: value === 'all' ? undefined : (value as UserStatus),
          })
        }
      >
        <SelectTrigger className="w-[150px]">
          <SelectValue placeholder="Statut" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Tous les statuts</SelectItem>
          {(Object.keys(USER_STATUS_CONFIG) as UserStatus[]).map((status) => (
            <SelectItem key={status} value={status}>
              {USER_STATUS_CONFIG[status].label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      {/* Bouton reset */}
      {hasFilters && (
        <Button
          variant="ghost"
          size="icon"
          onClick={handleClearFilters}
          className="shrink-0"
        >
          <X className="h-4 w-4" />
        </Button>
      )}
    </div>
  );
}
